import { Typography } from '@material-ui/core'
import { useStyles } from './styles'
const SectionHeader = (props) => {
  const { text } = props
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      <Typography className={classes.text}>{text}</Typography>
    </div>
  )
}
export default SectionHeader
